<template>
  <div class="reporting-grid-container">
    <!-- TODO: Animate notification bar down on enter and up on exit -->
    <div
      v-if="showPartialDataSetMessage"
      class="reporting-grid-notification--partial bg-info"
      @click="hidePartialDatasetNotification"
    >
      <i class="fa fa-times pull-right m-t-3 m-l-5" />

      <i class="fa fa-info m-t-3 m-r-5" />
      <span v-t="'PARTIAL_DATA_SET_MESSAGE'" />
    </div>

    <AgGridWrapper 
      :group-by="groupBy.field"
      :group-by-heirarchy="activeInsightGroupHierarchy"
      :grid-state="gridState"
      :export-data="exportData"
      :col-def-look-up="insightColumnDefLookup"
      :default-col-defs="insightColumns"
      :refresh-data="refreshGridData"
      :open-columns-tool-panel="openColumnsPanel"
      :toggle-quick-insights-panel="toggleQuickInsightsPanel"
      :initial-expand-all-groups="initialExpandAllGroups"
      :col-defs-loaded-from-api="colDefsLoadedFromAPI"
      @gridStateChange="onGridStateChange"
      @onGridTopLevelDataLoaded="onGridTopLevelDataLoaded"
      @showPartialDataNotification="showPartialDatasetNotification"
      @hidePartialDataNotification="hidePartialDatasetNotification"
      @cellClicked="e => $emit('cellClicked', e)"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import messages from './locales';
import AgGridWrapper from '@/core/components/AgGridWrapper';
import { INSIGHT_REPORT_TYPE } from '@/modules/reporting/store/state';
import partialDataSetMixin from '@/modules/reporting/mixins/partialDataSetMixin';

export default {
  name: 'ReportingGrid',
  components: { AgGridWrapper },
  mixins: [partialDataSetMixin],
  props: {
    /** 
     * The field name by which you want to group by
     */
    groupBy: {
      type: Object,
      required: true
    },
    openColumnsPanel: {
      type: Boolean,
      default: false
    },
    toggleQuickInsightsPanel: {
      type: Boolean,
      default: false
    },
    initialExpandAllGroups: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('reporting', [
      'insightColumnDefLookup',
      'activeInsightGroupHierarchy',
      'activeInsight',
      'activeInsightData',
      'insightColumns',
    ]),
    ...mapState('reporting', {
      exportData: state => state.exportInsightData,
      colDefsLoadedFromAPI: state => state.insight.colDefsLoadedFromAPI
    }),
    gridState() {
      return this.activeInsight.settings.groupSettings.gridState;
    },
    refreshGridData() {
      return this.activeInsightData?.refreshGridData;
    },
  },

  created () {
    this.setCurrentView(INSIGHT_REPORT_TYPE);
  },

  methods: {
    ...mapActions('reporting', [
      'setReportGridState',
      'setCurrentView'
    ]),
    onGridStateChange(gridState) {
      this.setReportGridState({ reportType: INSIGHT_REPORT_TYPE, state: gridState });
    },
    onGridTopLevelDataLoaded({data, requestHash}) {
      this.$emit('onGridTopLevelDataLoaded', {data, requestHash});
    },
  },
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style lang="scss" scoped>
.reporting-grid-container {
  height: 100%;
}
</style>